import { Outlet } from "react-router-dom";

import NavSlot from "@/components/navigation/links";
import React from "react";

export const jobTypes = [
  {
    label: "Dedicated",
    value: "dedicated",
    path: "/reports/billables/type/dedicated",
  },
  {
    label: "Fixed",
    value: "fixed",
    path: "/reports/billables/type/fixed",
  },
  {
    label: "Hourly",
    value: "hourly",
    path: "/reports/billables/type/hourly",
  },
  {
    label: "Bucket",
    value: "bucket",
    path: "/reports/billables/type/bucket",
  },
  {
    label: "Recurring",
    value: "recurring",
    path: "/reports/billables/type/recurring",
  },
];

export default function JobTypeReports() {
  return (
    <div className="flex-1 overflow-auto relative">
      <div className="sticky w-full bg-white z-1">
        <NavSlot navItems={jobTypes} />
      </div>

      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
